import { useState, useEffect } from "react";
import { updateUserQuota } from "../services/Quota_Service";
import { getAllClientByUsers } from "../services/Login_service";
import { format } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaSave } from "react-icons/fa";
import SuiviModal from "./SuiviModal";
import ModalOffre from "./ModalOffre";
import { getAllOffers, Offer, deleteOffer } from "../services/offreService";
import OfferCards from "./OfferCards";
import React from "react";
import OfferPurchasesList from "./OfferPurchasesList";


const DEFAULT_DAILY_QUOTA = 50;
const DEFAULT_MONTHLY_QUOTA = 200;


function GestionQuota() {
  const [filteredClient, setFilteredClient] = useState<any[]>([]);
  const [selectedEmails, setSelectedEmails] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [dailyQuota, setDailyQuota] = useState(DEFAULT_DAILY_QUOTA);
  const [monthlyQuota, setMonthlyQuota] = useState(DEFAULT_MONTHLY_QUOTA);
  const [message, setMessage] = useState("");
  const [activeTab, setActiveTab] = useState<"quota" | "offers">("quota");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [showModalOffre, setShowModalOffre] = useState(false);
  const [offers, setOffers] = useState<Offer[]>([]);
  const [selectedOffer, setSelectedOffer] = useState<Offer | undefined>(undefined);
  const storedRole = localStorage.getItem("role");
  const userRole: "CLIENT" | "ADMIN" = storedRole === "ADMIN" ? "ADMIN" : "CLIENT";

  useEffect(() => {
    getListUsers();

    const fetchOffers = async () => {
      try {
        const data = await getAllOffers();
        setOffers(data);
      } catch (error) {
        console.error("Erreur récupération offres :", error);
        toast.error("Impossible de récupérer les offres.");
      }
    };

    fetchOffers();
  }, []);

  const loadOffers = async () => {
    try {
      const data = await getAllOffers();
      setOffers(data);
    } catch (error) {
      console.error("Erreur récupération offres :", error);
      toast.error("Impossible de récupérer les offres.");
    }
  };


  const handleDelete = async (id: number) => {
    try {
      await deleteOffer(id);
      loadOffers();
    } catch (err: any) {
      toast.error(err.message);
    }
  };


  const getListUsers = async () => {
    setLoading(true);
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) throw new Error("Utilisateur non connecté");
      const clients = await getAllClientByUsers(parseInt(userId));
      const filteredClients = clients.filter(
        client => client.status !== "anonymous" && client.role !== "ADMIN"
      );
      setFilteredClient(filteredClients);
    } catch (error) {
      console.error("Erreur lors de la récupération des clients", error);
      toast.error("Erreur lors de la récupération des clients.");
    } finally {
      setLoading(false);
    }
  };

  const handleClientCheckboxChange = (email: string) => {
    setSelectedEmails(prev => {
      const newSet = new Set(prev);
      if (newSet.has(email)) newSet.delete(email);
      else newSet.add(email);
      return newSet;
    });
  };

  const handleSelectAll = () => setSelectedEmails(new Set(filteredClient.map(c => c.email)));
  const handleClearAll = () => setSelectedEmails(new Set());

  const handleUpdate = async () => {
    if (selectedEmails.size === 0) {
      toast.warning("Veuillez sélectionner au moins un utilisateur.");
      return;
    }

    try {
      const clientsToUpdate = filteredClient.filter(c => selectedEmails.has(c.email));
      for (const client of clientsToUpdate) {
        const newDailyQuota = dailyQuota ?? client.daily_email_quota ?? DEFAULT_DAILY_QUOTA;
        const newMonthlyQuota = monthlyQuota ?? client.monthly_email_quota ?? DEFAULT_MONTHLY_QUOTA;
        await updateUserQuota(client.email, newDailyQuota, newMonthlyQuota);
      }
      toast.success("Quotas mis à jour pour les utilisateurs sélectionnés !");
      await getListUsers();
      setSelectedEmails(new Set());
    } catch (err: any) {
      console.error("Erreur lors de la mise à jour du quota :", err);
      toast.error("Erreur lors de la mise à jour des quotas.");
    }
  };

  const handleResetQuotas = () => {
    setFilteredClient(prev =>
      prev.map(client =>
        selectedEmails.has(client.email)
          ? { ...client, daily_email_quota: DEFAULT_DAILY_QUOTA, monthly_email_quota: DEFAULT_MONTHLY_QUOTA }
          : client
      )
    );
    toast.info("Quotas des utilisateurs sélectionnés réinitialisés aux valeurs par défaut.");
  };

  // Tri
  const sortBy = (field: string) => {
    const sorted = [...filteredClient].sort((a, b) => {
      if (field === "createdAt") return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      return a[field].localeCompare(b[field]);
    });
    setFilteredClient(sorted);
  };
  return (
    <div>
      {message && <div className="alert alert-info">{message}</div>}

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3" role="tablist" style={{ cursor: "pointer" }}>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "quota" ? "active" : ""}`}
            onClick={() => setActiveTab("quota")}
            type="button"
          >
            Gérer le quota des clients
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "offers" ? "active" : ""}`}
            onClick={() => setActiveTab("offers")}
            type="button"
          >
            Gérer les offres
          </button>
        </li>
      </ul>

      {/* Tab panels */}
      {activeTab === "quota" && (
        <>
          {/* Sélection globale */}
          <div className="mb-4 d-flex flex-wrap align-items-center gap-3">
            <div className="d-flex flex-wrap align-items-center gap-2">
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={handleSelectAll}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <polyline points="9 11 12 14 20 6" />
                </svg>
                Tout sélectionner
              </button>

              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={handleClearAll}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                </svg>
                Tout désélectionner
              </button>
            </div>

            <div className="vr d-none d-md-block" style={{ height: "30px" }}></div>

            <button
              className="btn btn-primary d-flex align-items-center gap-2 shadow-sm"
              onClick={handleResetQuotas}
              style={{
                background: "linear-gradient(135deg, #4BB0C0 0%, #3A8C99 100%)",
                border: "none",
                transition: "all 0.3s ease",
                padding: "8px 16px",
                borderRadius: "10px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 12px rgba(75, 176, 192, 1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(66, 208, 230, 0.2)";
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 2v6h-6" />
                <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
                <path d="M3 22v-6h6" />
                <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
              </svg>
              Réinitialiser les quotas
            </button>
          </div>

          {/* Recherche */}
          <input
            type="text"
            placeholder="Rechercher par nom, prénom ou email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control my-2"
            style={{ width: "250px" }}
          />

      {/* Tableau */}
      <div className="table-responsive" style ={{ maxHeight: "400px", overflowY: "auto",overflowX:"auto" }}>
        <table className="table table-hover table-striped table-bordered align-middle">
          <thead>
            <tr>
              <th scope="col" className="text-center justify-content-center">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedEmails.size === filteredClient.filter(c => c.role !== "admin").length && filteredClient.filter(c => c.role !== "admin").length > 0}
                />
              </th>
              <th scope="col" className="text-center justify-content-center">Nom & Prénoms</th>
              <th scope="col" className="text-center justify-content-center">Date d'inscription</th>
              <th scope="col" className="text-center justify-content-center">Type</th>
              <th scope="col" className="text-center justify-content-center">Email</th>
              <th scope="col" className="text-center justify-content-center">Quota Journalier</th>
              <th scope="col" className="text-center justify-content-center">Quota Mensuel</th>
              <th scope="col" className="text-center justify-content-center">Actions</th>
              <th scope="col" className="text-center justify-content-center">Suivi</th>
            </tr>
          </thead>
              <tbody>
                {filteredClient
                  .filter(client => client.role !== "admin")
                  .filter(client => {
                    const search = searchTerm.toLowerCase();
                    const fullName = `${client.name} ${client.firstname}`.toLowerCase();
                    return fullName.includes(search) || client.email.toLowerCase().includes(search);
                  })
                  .map((client, idx) => (
                    <tr key={client.id} className="text-center justify-content-center "  >
                      <td className="text-center justify-content-center">
                        <div className="form-check text-center justify-content-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedEmails.has(client.email)}
                            onChange={() => handleClientCheckboxChange(client.email)}
                          />
                        </div>
                      </td>
                      <td>
                        <strong>{client.name} {client.firstname}</strong>
                      </td>
                      <td>{format(new Date(client.createdAt), "dd/MM/yyyy")}</td>
                      <td>
                        <span
                          className="badge"
                          style={{
                            backgroundColor:
                              client.user_type === "personne"
                                ? "#2F94A1"
                                : client.user_type === "professionnel"
                                  ? "#F4A261"
                                  : "#4BB0C0",
                            color: "white"
                          }}
                        >
                          {client.user_type === "personne"
                            ? "Particulier"
                            : client.user_type === "professionnel"
                              ? "Professionnel"
                              : "Entreprise"}
                        </span>
                      </td>

                      <td>
                        <span className="text-decoration-none" style={{ color: "#292f30ff" }}>
                          {client.email}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center text-center">
                          <input
                            type="number"
                            className="form-control form-control-sm text-center"
                            min={0}
                            style={{ width: "90px" }}
                            value={client.daily_email_quota ?? DEFAULT_DAILY_QUOTA}
                            onChange={(e) => {
                              const newQuota = Number(e.target.value);
                              setFilteredClient(prev => {
                                const copy = [...prev];
                                copy[idx] = { ...copy[idx], daily_email_quota: newQuota };
                                return copy;
                              });
                            }}
                          />
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center">
                          <input
                            type="number"
                            className="form-control form-control-sm text-center"
                            min={0}
                            style={{ width: "90px" }}
                            value={client.monthly_email_quota ?? DEFAULT_MONTHLY_QUOTA}
                            onChange={(e) => {
                              const newQuota = Number(e.target.value);
                              setFilteredClient(prev => {
                                const copy = [...prev];
                                copy[idx] = { ...copy[idx], monthly_email_quota: newQuota };
                                return copy;
                              });
                            }}
                          />
                        </div>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn  btn-sm"
                          type="button"
                          onClick={async () => {
                            try {
                              await updateUserQuota(
                                client.email,
                                client.daily_email_quota ?? DEFAULT_DAILY_QUOTA,
                                client.monthly_email_quota ?? DEFAULT_MONTHLY_QUOTA
                              );
                              toast.success(`Quota mis à jour pour ${client.email}`);
                              await getListUsers();
                            } catch (error) {
                              toast.error(`Erreur lors de la mise à jour pour ${client.email}`);
                            }
                          }}
                          title="Enregistrer ce quota"

                          style={{ backgroundColor: "#4BB0C0", borderColor: "#4BB0C0", color: "white", padding: "5px 10px" }}
                        >
                          <i className="bi bi-save text-center justify-content-center"></i>
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          title="Voir le suivi des envois"
                          className="btn"
                          onClick={() => {
                            setSelectedUser(client);
                            setModalVisible(true);
                          }}
                          style={{ backgroundColor: "#F4A261", borderColor: "#F4A261", color: "white", padding: "5px 10px" }}
                        >
                          <i className="bi bi-eye  text-center justify-content-center"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </div>

          {selectedUser && (
            <SuiviModal
              visible={modalVisible}
              onClose={() => setModalVisible(false)}
              user={selectedUser}
            />
          )}

          <div className="container py-2">
            <div className="settings-section bg-white border rounded-4 p-3 p-md-4 shadow-sm">

              {/* Quota journalier */}
              <div className="mb-4 pb-3 border-bottom">
                <div className="mb-2">
                  <label className="form-label fw-semibold fs-6 mb-1">
                    Quota journalier
                  </label>
                  <p className="text-muted small mb-0">Limite maximale par jour</p>
                </div>

                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-123 text-muted small"></i>
                  </span>
                  <input
                    type="number"
                    min="0"
                    className="form-control border-start-0 ps-1"
                    value={dailyQuota}
                    onChange={(e) => setDailyQuota(Number(e.target.value))}
                    placeholder="Limite quotidienne"
                  />
                  <span className="input-group-text bg-light">/jour</span>
                </div>

                <div className="form-text d-flex align-items-center mt-1">
                  <i className="bi bi-info-circle me-1 text-primary small"></i>
                  <span className="small">Sera appliqué chaque jour à minuit</span>
                </div>
              </div>

              {/* Quota mensuel */}
              <div className="mb-3">
                <div className="mb-2">
                  <label className="form-label fw-semibold fs-6 mb-1">
                    Quota mensuel
                  </label>
                  <p className="text-muted small mb-0">Limite maximale sur 30 jours</p>
                </div>

                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-123 text-muted small"></i>
                  </span>
                  <input
                    type="number"
                    min="0"
                    className="form-control border-start-0 ps-1"
                    value={monthlyQuota}
                    onChange={(e) => setMonthlyQuota(Number(e.target.value))}
                    placeholder="Limite mensuelle"
                  />
                  <span className="input-group-text bg-light">/mois</span>
                </div>

                <div className="form-text d-flex align-items-center mt-1">
                  <i className="bi bi-info-circle me-1 text-info small"></i>
                  <span className="small">Se réinitialise le premier de chaque mois</span>
                </div>
              </div>

              {/* Bouton */}
              <div className="mt-3">
                <button
                  className="btn btn-primary w-100 py-1 fw-semibold"
                  onClick={handleUpdate}
                >
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Mettre à jour les quotas
                </button>

                <p className="text-muted small mt-2 mb-0 d-flex align-items-center">
                  <i className="bi bi-clock-history me-1 small"></i>
                  Modifications appliquées immédiatement
                </p>
              </div>

            </div>
          </div>
        </>
      )}

      {activeTab === "offers" && (
        <>
          {/* Offers management panel */}
          <div className="mb-3">
            {/* <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Gestion des offres</h5>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setSelectedOffer(undefined);
                  setShowModalOffre(true);
                }}
              >
                Créer une offre
              </button>
            </div> */}
      <div className="mb-3 mb-md-0">
        <div className="d-flex align-items-center gap-2 mb-2">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2 d-flex align-items-center justify-content-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4BB0C0" strokeWidth="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h2 className="h4 mb-0 fw-bold text-dark">
            Liste des clients ayant acheté une offre
          </h2>
        </div>

      </div>
        {selectedOffer ? (
          
          <OfferPurchasesList offerId={selectedOffer.id} />
        ) : offers.length > 0 ? (
          <OfferPurchasesList offerId={offers[0].id} />
        ) : (
          <p>Aucune offre disponible pour afficher les utilisateurs.</p>
        )}

            <OfferCards
              offers={offers}
              setShowModalOffre={setShowModalOffre}
              setSelectedOffer={setSelectedOffer}
              handleDelete={handleDelete}
              userRole={userRole}
            />
          </div>
        </>
      )}

      <ModalOffre
        show={showModalOffre}
        onClose={() => {
          setShowModalOffre(false);
          setSelectedOffer(undefined);
        }}
        existingOffer={selectedOffer}
        onCreated={(offre) => {
          console.log("Offre créée ou modifiée :", offre);
          loadOffers();
        }}
      />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default GestionQuota;
